<div class="module-cards-container">
	<h2 class="ready-set-header">
		Next Level Features. <br />
		Next Level Compliance.
	</h2>

	<div class="row module-cards-grid">
		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/advanced-reporting.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient1
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient1
								"
								>Real-Time Reporting
							</strong>
							<p class="mt-2">
								Review your Security Scorecard in beautiful,<br
									class="d-none d-sm-block"
								/>
								intuitive dashboards. Access advanced report<br
									class="d-none d-sm-block"
								/>
								outs and business intelligence like you’ve
								never<br class="d-none d-sm-block" />
								seen it before with resources like PowerBI™.
							</p>
						</div>

						<a [routerLink]="['/documentation/advancedreporting']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img width="120px" src="../../assets/img/api.svg" alt="" />
			</div>

			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient2
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient2
								"
								>APIs
							</strong>
							<p class="mt-2">
								Seamlessly integrate external data sources in
								any <br class="d-none d-sm-block" />
								bespoke customer environment. Rely on our
								growing list of commercially supported
								integrations in Enterprise Edition including
								Slack, Teams, JIRA, ServiceNow, Tenable, Prisma, and Wiz.io.
							</p>
						</div>

						<a [routerLink]="['/documentation/apis']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					src="../../assets/img/transformer.svg"
					alt=""
				/>
			</div>

			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient3
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient3
								"
								>Transformer
							</strong>
							<p class="mt-2">
								Map your controls across frameworks and
								<br class="d-none d-sm-block" />
								toggle versions of security plans in one central
								<br class="d-none d-sm-block" />
								location.
							</p>
						</div>

						<a [routerLink]="['/documentation/transformer']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					src="../../assets/img/deploy-anywhere.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="
						regscale-works-card-inner
						module-cards-linear-gradient4
					"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="
									regscale-works-card
									module-cards-linear-gradient4
								"
								>Deploy Anywhere
							</strong>
							<p class="mt-2">
								All users can seamlessly deploy RegScale in a<br
									class="d-none d-sm-block"
								/>
								Linux Docker Container. There are additional<br
									class="d-none d-sm-block"
								/>
								deployment options for Enterprise users<br
									class="d-none d-sm-block"
								/>
								including an ISO Appliance. Get
								in<br class="d-none d-sm-block" />
								touch with our team to find out more.
							</p>
						</div>

						<a [routerLink]="['/documentation/catalogues']">
							<button
								class="shift-compliance-btn bg-white py-2 px-5"
							>
								Learn More
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="cards-collapse">
		<div class="row module-cards-grid mb-5">
			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/3rd-party-risk.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>3rd Party Risk
								</strong>
								<p class="mt-2">
									Provide a company's supply chain contracts
									and/or <br class="d-none d-sm-block" />
									vendors with a calculated risk score across
									multiple <br class="d-none d-sm-block" />
									factors.
								</p>
							</div>

							<a [routerLink]="['/documentation/thirdpartyrisk']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/mentions.svg"
						alt=""
					/>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>@Mentions
								</strong>
								<p class="mt-2">
									RegScale’s familiar notification system uses
									<br class="d-none d-sm-block" />
									@mentions to notify users of new comments,
									<br class="d-none d-sm-block" />
									workflow actions, or News Feed threads for
									real- <br class="d-none d-sm-block" />time
									collaboration.
								</p>
							</div>

							<a [routerLink]="['/documentation/mentions']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						height="120px"
						src="../../assets/img/adldap.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>AD/LDAP
								</strong>
								<p class="mt-2">
									Authenticate to RegScale using your existing
									<br class="d-none d-sm-block" />
									systems such as Active Directory (AD) or
									<br class="d-none d-sm-block" />
									Lightweight Directory Access Protocol (LDAP)
									to <br class="d-none d-sm-block" />
									maximize your existing security investments.
								</p>
							</div>

							<a [routerLink]="['/documentation/authentication']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/builders.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Builders
								</strong>
								<p class="mt-2">
									The Next->Next->Finish wizard-style approach
									builds <br class="d-none d-sm-block" />
									compliance artifacts that map to dozens of
									related <br class="d-none d-sm-block" />
									regulations in minutes.
								</p>
							</div>

							<a [routerLink]="['/documentation/builders']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/compliance-explorer.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Compliance Explorer
								</strong>
								<p class="mt-2">
									A Windows Explorer-like feature for
									organizing <br class="d-none d-sm-block" />
									complex relationships between compliance
									<br class="d-none d-sm-block" />
									artifacts.
								</p>
							</div>

							<a [routerLink]="['/documentation/explorer']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/custom-fields.svg"
						alt=""
					/>
				</div>

				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>Custom Fields
								</strong>
								<p class="mt-2">
									Extend the RegScale schema with custom
									fields to <br class="d-none d-sm-block" />
									capture customer-specific data for any
									compliance <br class="d-none d-sm-block" />
									process.
								</p>
							</div>

							<a [routerLink]="['/documentation/custom-fields']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/dashboards.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Dashboards
								</strong>
								<p class="mt-2">
									Use out-of-the-box reporting to visualize
									the <br class="d-none d-sm-block" />
									state of compliance against all RegScale
									<br class="d-none d-sm-block" />
									modules, including time visualizations,
									graphs, <br class="d-none d-sm-block" />
									and expired/upcoming lists.
								</p>
							</div>

							<a [routerLink]="['/documentation/dashboards']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/email.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Email
								</strong>
								<p class="mt-2">
									Send compliance notifications to your
									employees <br class="d-none d-sm-block" />
									and stakeholders via email.
								</p>
							</div>

							<a [routerLink]="['/documentation/email']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/evidence-management.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Evidence Management
								</strong>
								<p class="mt-2">
									Store compliance evidence on the record that
									is fully <br class="d-none d-sm-block" />
									AES-256 encrypted, MD5 hashed, and available
									on- <br class="d-none d-sm-block" />demand
									for auditors.
								</p>
							</div>

							<a [routerLink]="['/documentation/evidence']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/excel-report.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>Excel Export
								</strong>
								<p class="mt-2">
									Easily export and download your data in
									Excel for <br class="d-none d-sm-block" />
									external processing.
								</p>
							</div>

							<a [routerLink]="['/documentation/excel']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/gis-maps.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>GIS Maps
								</strong>
								<p class="mt-2">
									View the status of compliance with a
									fly-over <br class="d-none d-sm-block" />
									GIS map.
								</p>
							</div>

							<a [routerLink]="['/documentation/gis']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/history.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>History
								</strong>
								<p class="mt-2">
									Proactively monitor security by logging all
									user <br class="d-none d-sm-block" />
									activity related to every RegScale record.
								</p>
							</div>

							<a [routerLink]="['/documentation/history']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/iso-compliance.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>ISO Appliance
								</strong>
								<p class="mt-2">
									The most straightforward deployment process
									<br class="d-none d-sm-block" />
									possible. Be up and running in minutes in
									any <br class="d-none d-sm-block" />
									VMware, Hyper-V, or cloud environment.
								</p>
							</div>

							<a [routerLink]="['/documentation/appliance']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/metadata.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Metadata
								</strong>
								<p class="mt-2">
									Customize picklists in forms with your
									organization's
									<br class="d-none d-sm-block" />
									metadata to align with unique and finely
									tuned <br class="d-none d-sm-block" />
									business processes that rely on collecting
									specific <br class="d-none d-sm-block" />
									data.
								</p>
							</div>

							<a [routerLink]="['/documentation/metadata']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/multi-tenancy.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Multi-Tenancy
								</strong>
								<p class="mt-2">
									Get the power of the cloud behind the user
									firewall <br class="d-none d-sm-block" />
									and allow CIOs to consolidate compliance
									systems <br class="d-none d-sm-block" />
									while meeting the unique needs of each
									internal <br class="d-none d-sm-block" />
									customer.
								</p>
							</div>

							<a [routerLink]="['/documentation/multi-tenancy']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/news-feed.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>News Feed
								</strong>
								<p class="mt-2">
									See real-time streaming feed of important
									<br class="d-none d-sm-block" />
									compliance events for your organization.
									Think of <br class="d-none d-sm-block" />
									this as the LinkedIn news feed for
									compliance.
								</p>
							</div>

							<a [routerLink]="['/documentation/newsfeed']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/relationship-manager.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient1
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient1
									"
									>Relationship Manager
								</strong>
								<p class="mt-2">
									Provides the ability to establish
									non-hierarchical
									<br class="d-none d-sm-block" />
									relationships between records.
								</p>
							</div>

							<a [routerLink]="['/documentation/relationships']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img width="120px" src="../../assets/img/rmf.svg" alt="" />
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Risk Management Framework (RMF)
								</strong>
								<p class="mt-2">
									Align compliance controls and requirements  <br class="d-none d-sm-block" />
									with their associated risks.
								</p>
							</div>

							<a [routerLink]="['/documentation/rmf']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/scheduling.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Scheduling
								</strong>
								<p class="mt-2">
									Drive accountability, view progress against
									the <br class="d-none d-sm-block" />
									schedule, and ensure you never miss another
									<br class="d-none d-sm-block" />
									compliance deadline through automated tools
									for <br class="d-none d-sm-block" />
									building audit/assessment schedules or
									scheduling <br class="d-none d-sm-block" />
									recurring audits, data calls, or tasks.
								</p>
							</div>

							<a [routerLink]="['/documentation/scheduling']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/service-accounts.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Service Accounts
								</strong>
								<p class="mt-2">
									Allow customers to programmatically access
									APIs <br class="d-none d-sm-block" />
									without the use of usernames and passwords,
									<br class="d-none d-sm-block" />
									thereby improving security.
								</p>
							</div>

							<a
								[routerLink]="[
									'/documentation/service-accounts'
								]"
							>
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/slack-integration.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Slack/Teams Integrations
								</strong>
								<p class="mt-2">
									Collaborate in real-time with other
									compliance <br class="d-none d-sm-block" />
									professionals using your existing
									collaboration tools.
								</p>
							</div>

							<a [routerLink]="['/documentation/collaboration']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/timeline.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient2
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient2
									"
									>Timeline
								</strong>
								<p class="mt-2">
									No need for Visio, build interactive
									timelines using
									<br class="d-none d-sm-block" />
									our tools to document all related events for
									a given <br class="d-none d-sm-block" />
									RegScale record.
								</p>
							</div>

							<a [routerLink]="['/documentation/timeline']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/transformer.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Transformer
								</strong>
								<p class="mt-2">
									Provide customers the ability to map
									controls <br class="d-none d-sm-block" />
									across frameworks and toggle versions of
									security <br class="d-none d-sm-block" />
									plans.
								</p>
							</div>

							<a [routerLink]="['/documentation/transformer']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/workbench.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient3
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient3
									"
									>Workbench
								</strong>
								<p class="mt-2">
									With the vast array of compliance modules
									available <br class="d-none d-sm-block" />
									in RegScale, we provide a simple way to view
									all <br class="d-none d-sm-block" />
									compliance-related deliverables that require
									your <br class="d-none d-sm-block" />
									attention.
								</p>
							</div>

							<a [routerLink]="['/documentation/workbench']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mb-5">
				<div class="regscale-works-card-bottom">
					<img
						width="120px"
						src="../../assets/img/workflow.svg"
						alt=""
					/>
				</div>
				<div class="regscale-works-card-outer px-3 pt-2 pb-3">
					<div
						class="
							regscale-works-card-inner
							module-cards-linear-gradient4
						"
					>
						<div
							class="
								regscale-works-content
								px-3 px-xl-4
								text-center
							"
						>
							<div>
								<strong
									class="
										regscale-works-card
										module-cards-linear-gradient4
									"
									>Workflow
								</strong>
								<p class="mt-2">
									Automate your manual business processes
									using <br class="d-none d-sm-block" />
									RegScale’s drag and drop workflow builder
									without <br class="d-none d-sm-block" />
									needing an army of
									<br class="d-none d-sm-block" />
									developers and months of programming to meet
									your requirements.
								</p>
							</div>

							<a [routerLink]="['/documentation/workflow']">
								<button
									class="
										shift-compliance-btn
										bg-white
										py-2
										px-5
									"
								>
									Learn More
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="mt-5">
		<button
			(click)="toggleCollapse()"
			id="full-list"
			class="shift-compliance-btn bg-white py-2 px-5 m-auto"
		>
			Check Out Our Full List
		</button>
		<button
			(click)="toggleCollapse()"
			id="see-less"
			class="shift-compliance-btn bg-white py-2 px-5 m-auto"
		>
			See less
		</button>
	</div>
</div>
